import React from 'react';
import { HOSupplementSection } from '../../Layout/SupplementSection/SupplementSection';
import { Col, Container, Row } from 'react-bootstrap';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
var linkList = [
    {
        link_title: 'Legal notice',
        url: 'https://www.hetzner.com/rechtliches/impressum'
    },
    {
        link_title: 'Data privacy',
        url: 'https://www.hetzner.com/rechtliches/datenschutz'
    },
    {
        link_title: 'System policies',
        url: 'https://www.hetzner.com/rechtliches/system-policies'
    },
    {
        link_title: ' Terms and conditions',
        url: 'https://www.hetzner.com/rechtliches/agb'
    }
];
var FooterLink = function (_a) {
    var linkColorClass = _a.linkColorClass, index = _a.index, url = _a.url, linkTitle = _a.link_title;
    return (React.createElement("li", { key: "footer-link-" + index, className: 'list-inline-item m-0 px-1' },
        React.createElement("a", { className: "font-weight-bold text-decoration-none " + linkColorClass, href: url, target: '_blank' }, linkTitle)));
};
var FooterLinkList = function (_a) {
    var linkColorClass = _a.linkColorClass;
    return (React.createElement("ul", { className: 'list-unstyled list-inline text-center m-0 footer-links-list' }, linkList.map(function (link, index) {
        return (React.createElement(FooterLink, { index: index, key: index, url: link.url, linkColorClass: linkColorClass, link_title: link.link_title }));
    })));
};
var HOFooter = function (props) {
    var footerColor = props.footerColor, supplementColor = props.supplementColor, hasSupplement = props.hasSupplement, mirrorSupplements = props.mirrorSupplements, showCopyRight = props.showCopyRight, showLinks = props.showLinks;
    var isBlack = footerColor === 'black';
    var isWhite = footerColor === 'white';
    var footerClasses = classNames("pt-4 pb-3", { 'bg-black text-white ': isBlack }, { 'bg-white text-black': isWhite });
    var linkClasses = classNames({ 'text-white ': isBlack }, { 'text-black': isWhite });
    return (React.createElement("footer", null,
        hasSupplement && (React.createElement(HOSupplementSection, { color: mirrorSupplements ? footerColor : supplementColor })),
        React.createElement("div", { className: footerClasses },
            React.createElement(Container, null,
                React.createElement(Row, null,
                    React.createElement(Col, { xl: 12, lg: 12, md: 12, sm: 12, xs: 12 },
                        React.createElement("div", { className: 'text-center' }, showCopyRight &&
                            '© 2019. Hetzner Online GmbH. All Rights Reserved.'))),
                React.createElement(Row, null,
                    React.createElement(Col, { xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }, showLinks && React.createElement(FooterLinkList, { linkColorClass: linkClasses })))))));
};
HOFooter.propTypes = {
    footerColor: PropTypes.string.isRequired,
    showLinks: PropTypes.bool,
    hasSupplement: PropTypes.bool,
    mirrorSupplements: PropTypes.bool,
    showCopyRight: PropTypes.bool
};
export { HOFooter };
